module.exports = __webpack_public_path__ + "img/MELA_CD8Tex.2026c663.png";